import { ReactChildren, ReactFragment } from 'react'
import { useState } from 'react'
import styles from '@/styles/Manage.module.scss'
import modalStyles from '@/styles/Modal.module.css'
import buttonStyles from '@/styles/Buttons.module.scss'
import formStyles from '@/styles/Forms.module.scss'
import colorStyles from '@/styles/Colors.module.scss'
import utilityStyles from '@/styles/UtilityStyles.module.scss'
import { Box, Modal } from '@mui/material'
import { TextField } from '@material-ui/core'
import classNames from 'classnames'
import WaitlistEntryModalTitle from '../pages/waitlist/WaitlistEntryModal/WaitlistEntryModalTitle'
import { setAlert, setIsAlertOpen } from '@/store/slices/alertSlice'
import { useDispatch } from 'react-redux'
import { printAxiosErrors } from '@/utils/util-functions'
import { useRouter } from 'next/router'
import { H6 } from './Typography'

interface ActionModalProps {
  objectForAction: any // use selectedBusinessId, just need object name here?
  action: Function
  isActionBlocked: boolean
  actionBlockedModalContent: ReactFragment
  buttonText: Text
  buttonStyle?: string[] // array of options, buttonStyle: pill, text, color, iconOverride
  confirmationString: string
  confirmationContent: ReactFragment | string
  alertSuccessTitle: string
  alertSuccessMessage: string
  successRedirectRoute?: string
  iconSrc: string
  modalTitle: string
  modalSubtitle: string
  modalContent: string
  modalControlButtons?: {
    cancelText?: string
    confirmText?: string
  }
}
const ActionModalTextConfirm = ({
  objectForAction,
  action,
  alertSuccessTitle = 'Success',
  alertSuccessMessage,
  buttonText,
  buttonStyle,
  confirmationString,
  modalTitle,
  iconSrc = '/icons/delete.svg',
  modalSubtitle,
  modalContent,
  modalControlButtons = {
    cancelText: 'Nevermind',
    confirmText: 'Confirm',
  },
  successRedirectRoute = '/waitlist',
  isActionBlocked = false,
  actionBlockedModalContent = null,
}) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [isConfirmStringValid, setIsConfirmStringValid] = useState(false)
  const { flex, flexRow, itemsCenter, gap4, cursorPointer } = utilityStyles
  const addDisabledBtnStyle = !isConfirmStringValid
    ? buttonStyles.disabledBtn
    : ''
  const confirmBtnClasses = isActionBlocked
    ? [buttonStyles.twilightBtn]
    : [buttonStyles.redBtn, addDisabledBtnStyle]
  const validateConfirmationString = (e) => {
    if (e.target.value === confirmationString) {
      setIsConfirmStringValid(true)
    } else {
      setIsConfirmStringValid(false)
    }
  }

  const cancelAction = () => {
    setIsConfirmModalOpen(false)
  }

  const confirmAction = async () => {
    if (isActionBlocked) {
      setIsConfirmModalOpen(false)
      router.push('mailto:support@nextmeapp.com')
      return
    }
    try {
      await action()
      setIsConfirmModalOpen(false)
      setIsConfirmStringValid(false)
      dispatch(
        setAlert({
          isOpen: true,
          title: alertSuccessTitle,
          type: 'success',
          message: alertSuccessMessage,
          alertDuration: 3000,
        })
      )
      setTimeout(() => {
        dispatch(setIsAlertOpen(false))
        router.replace(successRedirectRoute)
      }, 3000)
    } catch (err) {
      dispatch(
        setAlert({
          isOpen: true,
          title: err.response?.data?.message,
          type: 'error',
          message: printAxiosErrors(err, true),
        })
      )
    }
  }
  return (
    <>
      <div
        className={classNames(flex, flexRow, itemsCenter, gap4, cursorPointer)}
        style={{
          maxWidth: '180px',
        }}
        onClick={() => {
          setIsConfirmModalOpen(true)
          setIsConfirmStringValid(false)
        }}
      >
        <img src={iconSrc} width="24px" alt="" />
        <span
          className={classNames(colorStyles.red)}
          style={{ marginTop: '4px', fontWeight: 'bold' }}
        >
          {buttonText}
        </span>
      </div>
      <Modal open={isConfirmModalOpen} onClose={cancelAction}>
        <Box className={modalStyles.modalBox}>
          <WaitlistEntryModalTitle icon={iconSrc} title={modalTitle} />
          <H6 style={{ marginBottom: '16px', fontWeight: '600' }}>{modalSubtitle}</H6>
          <p>{isActionBlocked ? actionBlockedModalContent : modalContent}</p>
          <br />
          {!isActionBlocked && (
            <Box
              style={{
                marginBottom: '24px',
              }}
            >
              <label style={{ fontWeight: 'bold' }}>
                Type {confirmationString} to confirm
              </label>
              <TextField
                name="confirmValidation"
                variant="outlined"
                className={classNames(formStyles.inputField)}
                type="text"
                onChange={(e) => {
                  validateConfirmationString(e)
                }}
                style={{
                  width: '100%',
                }}
              />
            </Box>
          )}

          <Box className={modalStyles.modalButtonRow}>
            <button
              className={classNames(buttonStyles.grayBtn)}
              onClick={cancelAction}
            >
              {modalControlButtons.cancelText || 'Nevermind'}
            </button>
            <button
              disabled={!isActionBlocked && !isConfirmStringValid}
              className={classNames(confirmBtnClasses)}
              onClick={confirmAction}
            >
              {isActionBlocked ? 'Contact Us' : modalControlButtons.confirmText}
            </button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ActionModalTextConfirm
